import styles from './W_PaymentTreeDonateContent.module.css';
import W_PaymentTreeDonateBilling from '../W_PaymentTreeDonateBilling/W_PaymentTreeDonateBilling';
import W_PaymentTreeDonate from '../W_PaymentTreeDonate/W_PaymentTreeDonate';
import W_PaymentCard from '../W_PaymentCard/W_PaymentCard';

interface W_PaymentTreeDonateContentProps {
  progress: number;
  totalDonations: number;
  cost: number;
  name: string;
  donorsCount: number;
}

export default function W_PaymentTreeDonateContent({
  progress,
  totalDonations,
  cost,
  name,
  donorsCount,
}: W_PaymentTreeDonateContentProps) {
  return (
    <div className={styles.wrapper}>
      <W_PaymentTreeDonateBilling
        progress={progress}
        totalDonations={totalDonations}
        cost={cost}
        name={name}
        donorsCount={donorsCount}
      />
      <W_PaymentCard />
      <W_PaymentTreeDonate />
    </div>
  );
}
